import type { Mutation } from '@tahi/core';
import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

/**
 * SERVER-ONLY. The append-only change log devices pull from (conventions §6).
 * seq is the pull cursor. mutation_id is unique so a re-sent push is acknowledged, not re-applied.
 */
export const changes = sqliteTable(
  'changes',
  {
    seq: integer('seq').primaryKey({ autoIncrement: true }),
    userId: text('user_id').notNull(),
    deviceId: text('device_id').notNull(),
    mutationId: text('mutation_id').notNull().unique(),
    mutation: text('mutation', { mode: 'json' }).$type<Mutation>().notNull(),
    receivedAt: text('received_at').notNull(),
  },
  (t) => [index('changes_user_seq_idx').on(t.userId, t.seq)],
);

/**
 * DEVICE-ONLY. Mutations written locally and not yet acknowledged by the server.
 * The table also exists (empty) in D1 because both sides share one migration set.
 */
export const outbox = sqliteTable('outbox', {
  mutationId: text('mutation_id').primaryKey(),
  mutation: text('mutation', { mode: 'json' }).$type<Mutation>().notNull(),
  createdAt: text('created_at').notNull(),
  attempts: integer('attempts').notNull().default(0),
  lastError: text('last_error'),
});

/**
 * DEVICE-ONLY. Small key/value store for the sync client (pull cursor, device id, ...).
 * The table also exists (empty) in D1 because both sides share one migration set.
 */
export const syncState = sqliteTable('sync_state', {
  key: text('key').primaryKey(),
  value: text('value').notNull(),
});
